module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Hainan Island, China")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Zeus felt his heart pound")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("against his chest")]), _vm._v(". He couldn’t slow it; the best he could do was control his breathing, taking deep, long breaths as he followed the Chinese military officer down the hallway. Christian was a few strides behind; the two Chinese soldiers were a pace or so to the rear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The worst thing to do was panic. The Chinese had no way of knowing that they were involved in the attack; as long as he kept his mouth shut, they would ultimately have to release him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unless the Vietnamese spy had given them away. Then what?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus slowed down another half step. “Let me do the talking,” he whispered to Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They’ll split us up,” said Christian. “And where’s the girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The tremble was more pronounced, his voice unusually high.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re here on business. Hong Kong. Then Tokyo. We’re businessmen,” said Zeus. “Stay with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The cover story didn’t go very deep. How long would it take to get enough information for inconsistencies? Fifteen minutes? A half hour?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If Solt or one of the Vietnamese marines who’d been on the mission with them had been captured, the Chinese would expect them to lie. But there was no other alternative.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Stick to the story,” Zeus whispered as the Chinese officer opened a steel door near the gate entrance hall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That bitch must’ve sold us out,” said Christian under his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The door opened into a claustrophobically small room flooded with neon-bright light from above. Two men stood at the opposite end of the room. They wore blue fatigues with no insignias. To the right was a large corkboard covered with squares of paper tacked into neat rows. The squares were covered with Chinese characters, all unintelligible to Zeus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The two men who had followed them came inside and closed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Passports,” said the officer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As Zeus reached to his pocket, it occurred to him that it might just be a simple shakedown—not unheard of at small airports in China.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If so, he should slip some cash into the passport before he handed it over. But that was risky, too. The man might be insulted. Worse, it might be too little.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He gave him only the passport. Christian’s hand shook as he handed his over.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Buck up. Don’t go to pieces on me now.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What’s this about?” Zeus asked calmly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The officer ignored him, examining the documents. Though the room was small, it had a pair of air-conditioning vents, and it actually seemed cool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man said something in Chinese. The two men near the door, barely a foot away from Zeus, stiffened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go with them,” the officer said to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What is this about?” asked Zeus, a little harsher.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Our passports.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The officer stared so hard Zeus thought he was going to go cross-eyed. The passports remained in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What would he do if Zeus grabbed them from his hand?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus could bowl him over with a swipe of his hand, a hard shot to his throat. Then push against the other two goons behind him, grab one of their guns. But that left the other two men for Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The major had surprised him over the past few days, but he was worn down now, tired by everything they’d done.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And what would they do next? Even if they had their weapons?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of the men opened the door and stepped back into the hallway. Zeus followed warily, trying to decide what to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What the hell are they up to?” asked Christian, walking alongside of him. “Are they arresting us? Or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe they’re going to take us out and shoot us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe, thought Zeus.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man leading them walked toward the main part of the terminal. He took long strides. Zeus quickened his own pace, closing the distance. He glanced over his shoulder; Christian lagged nearly five yards behind, with the other guard a short distance behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This seemed too casual for an arrest. But maybe that was the idea: keep things calm so there was less chance of trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus closed the distance between him and the Chinese soldier. He reached his hand up, plotting what he would do—grab the man’s shoulder, pull him around, hit him with his other fist. But before he was quite close enough, the soldier turned slightly and pushed against a glass door that led to a set of steel stairs outside the building.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus followed. It took his eyes a moment to adjust to the harsh light; when they did, he saw an armored personnel carrier sitting about ten yards away. Light spilled from the interior. A half-dozen soldiers sat inside, assault guns between splayed legs, cigarette smoke wafting across the warm night air. There were more soldiers, and more vehicles, a short distance away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We are truly fucked,” said Christian, coming down the steps.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man behind them said something in Chinese; probably "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Hurry up.")]), _vm._v(" Their guide was approaching a large two-and-a-half-ton truck beyond the APC.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zeus rubbed his face. He’d missed his chance inside. With all these guards around, what the hell was he going to do?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And where the hell was Solt?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57722966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 98
// module chunks = 0